package com.arenaproplay.admin.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.arenaproplay.admin.navigation.Routes

/**
 * Legacy /insights route — redirects to /analytics?tab=behavior.
 *
 * Content (retention cohorts, signup funnel, event lifecycle, onboarding) has
 * fully moved to the «Поведение» tab of AnalyticsPage (R6).
 * This stub keeps old bookmarks/external links working.
 */
@Page("/insights")
@Composable
fun InsightsPage() {
    val ctx = rememberPageContext()
    LaunchedEffect(Unit) {
        ctx.router.navigateTo("${Routes.ANALYTICS}?tab=behavior")
    }
}
